// extracted by mini-css-extract-plugin
export default {"Snackbar":"SnackBar_Snackbar__60y5c","viewNotification":"SnackBar_viewNotification__11NTh"};